import React, { Component } from 'react';


// import { BrowserRouter as Router, Route, Switch } from 'react-router';

import { apiPut, apiPost, apiGet, apiDelete } from '../../Api';
import EnemyTypeList from './Admin_EnemyTypes_List';
import EnemyTypeDetail from './Admin_EnemyTypes_Detail';
import AdminAPI from './AdminAPI';

export default class Admin_EnemyTypes extends Component {


  constructor(props) {
    super(props);
    this.state = {
      enemytypes: [], // Load this from your backend
      rarity: [],
      creatingNewEnemyType: false,
      selectedEnemyTypeId: ""
    }
  }




  componentDidMount = async () => {
    //enemyTypes
    this.getEnemyTypes();
    //rarity
    var rarity = await AdminAPI.getRarity();
    rarity.sort((a, b) => b.dropChance - a.dropChance);
    this.setState({ rarity: rarity });

  }

  getEnemyTypes = async () => {

    var enemytypes = await AdminAPI.getEnemyTypes();
    enemytypes.sort((a, b) => b.rarityDropChanceModifier[0].dropChanceModifier - a.rarityDropChanceModifier[0].dropChanceModifier);
    this.setState({ enemytypes: enemytypes });
  }

  handleSelectEnemyType = (enemytype) => {

    this.setState({
      selectedEnemyType: enemytype,
      creatingNewEnemyType: false,
      selectedEnemyTypeId: enemytype.id,
    });

  };

  handleNewEnemyType = () => {
    this.setState({
      creatingNewEnemyType: true,
      selectedEnemyType: {},
      selectedEnemyTypeId: ""
    });
  };


  handleCancelCreate = () => {
    this.setState({
      selectedEnemyType: null,
      creatingNewEnemyType: false,
    });
  };

  handleUpdate = async (enemytype) => {
    const response = await apiPut("/enemytype", JSON.stringify(enemytype));
    if (response.ok) {
      this.getEnemyTypes();
      this.setState({ selectedEnemyTypeId: null });
    }
  };

  handleDelete = async (enemytype) => {
    // Send delete request to your backend
    const response = await apiDelete("/enemytype/" + enemytype.id);
    if (response.ok) {
      this.getEnemyTypes();
      this.setState({ selectedEnemyTypeId: null });
    }
  };

  handleCreate = async (enemytype) => {
    // Send delete request to your backend
    const response = await apiPost("/enemytype", JSON.stringify(enemytype));

    if (response.ok) {
      this.getEnemyTypes();
      this.setState({ selectedEnemyTypeId: null });
    }
    else {
      window.alert(response.text());
    }
  };


  // getEnemyTypes = async () => {
  //   const response = await apiGet("/enemytype");
  //   if (response.ok) {
  //     // console.log(response.json());
  //     const enemytypes = await response.json();
  //     this.setState({ enemytypes });
  //   }
  // };


  // findSelectedEnemyType = () => {

  //   return this.state.enemytypes.find((c) => c.id === this.state.selectedEnemyTypeId);

  // }



  render() {
    const { enemytypes, creatingNewEnemyType } = this.state;

    return (
      <div className="admin-settingspage">
        <EnemyTypeList
          enemytypes={enemytypes}
          onSelectEnemyType={this.handleSelectEnemyType}
          onSearch={this.handleSearch}
          onNewEnemyType={this.handleNewEnemyType}
        />



        <EnemyTypeDetail
          creatingNewEnemyType={creatingNewEnemyType}
          enemytypeId={this.state.selectedEnemyTypeId}
          rarities={this.state.rarity}
          onUpdate={this.handleUpdate}
          onDelete={this.handleDelete}
          onCreate={this.handleCreate}
          onCancelCreate={this.handleCancelCreate}
        />

      </div>
    );
  }
}
